import React, { Fragment } from 'react';
import { Loader, LOADER_SIZE } from '@domain-group/fe-blueprint-ui/loader';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { ProfileIcon } from '@domain-group/fe-co-icon';
import { MenuItem } from '../menu';
import * as styles from './membership-buttons.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MembershipButtons = _ref => {
  var _ref$isSignedIn = _ref.isSignedIn,
    isSignedIn = _ref$isSignedIn === void 0 ? false : _ref$isSignedIn,
    _ref$isIdentityLoaded = _ref.isIdentityLoaded,
    isIdentityLoaded = _ref$isIdentityLoaded === void 0 ? false : _ref$isIdentityLoaded,
    user = _ref.user,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'compact' : _ref$appearance,
    profileExpanded = _ref.profileExpanded,
    className = _ref.className,
    _ref$onSignInClicked = _ref.onSignInClicked,
    onSignInClicked = _ref$onSignInClicked === void 0 ? () => {} : _ref$onSignInClicked,
    _ref$onSignUpClicked = _ref.onSignUpClicked,
    onSignUpClicked = _ref$onSignUpClicked === void 0 ? () => {} : _ref$onSignUpClicked,
    onProfileMenuClicked = _ref.onProfileMenuClicked;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  if (!isIdentityLoaded) {
    return ___EmotionJSX("div", {
      css: styles.spinner
    }, ___EmotionJSX(Loader, {
      size: LOADER_SIZE.MINI
    }));
  }
  if (isSignedIn) {
    return appearance === 'embedded' ? null : ___EmotionJSX("div", null, ___EmotionJSX(MenuItem, {
      expander: profileExpanded ? 'open' : 'closed',
      orientation: "row",
      indicator: true,
      onClick: onProfileMenuClicked,
      onExpandClick: onProfileMenuClicked,
      label: ___EmotionJSX(ProfileIcon, {
        title: user === null || user === void 0 ? void 0 : user.email
      })
    }));
  }
  var handleSignInClicked = () => {
    sendEvent('sign-in');
    onSignInClicked();
  };
  var handleSignUpClicked = () => {
    sendEvent('sign-up');
    onSignUpClicked();
  };
  return ___EmotionJSX(Fragment, null, ___EmotionJSX(Button, {
    className: className,
    css: styles.memberButton,
    onClick: handleSignInClicked,
    stretched: appearance === 'embedded',
    size: appearance === 'embedded' ? 'regular' : 'small',
    appearance: appearance === 'embedded' ? 'outline' : 'ghostNeutral'
  }, "Sign in"), appearance === 'full' || appearance === 'embedded' ? ___EmotionJSX(Button, {
    className: className,
    size: appearance === 'embedded' ? 'regular' : 'small',
    appearance: "primary",
    stretched: appearance === 'embedded',
    css: styles.memberButton,
    onClick: handleSignUpClicked
  }, "Sign up") : null);
};
export default MembershipButtons;